import { useParams } from "react-router-dom";
import  {MainContentPhysical} from "../maincontent-physical/maincontent-physical";
import "./Physical-Assessment.css";

export const PhysicalDashboard = () => {
  const { domain } = useParams();

  return (
    <div className="physical-dashboard">
      <div className="maincontentarea-physical">
        <MainContentPhysical /> 
      </div>
    </div>
  );
};

